import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "login"
const LoginIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21 2.25C21.828 2.25 22.5 2.922 22.5 3.75V20.25C22.5 21.078 21.828 21.75 21 21.75H11.25C10.422 21.75 9.75 21.078 9.75 20.25V14.25H11.25V20.25H21V3.75H11.25V9.75H9.75V3.75C9.75 2.922 10.422 2.25 11.25 2.25z" />
          <path d="M19.436 12 14.03 17.405 12.97 16.345 16.564 12.75H1.5V11.25H16.564L12.97 7.655 14.03 6.595z" />
        </svg>
      }
    </span>
  )
}
export default LoginIcon
